"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const error_1 = require("@apollo/client/link/error");
const onNetworkError_1 = (0, tslib_1.__importDefault)(require("./onNetworkError"));
const handleTwoFactor_1 = (0, tslib_1.__importDefault)(require("./handleTwoFactor"));
exports.default = options => (0, error_1.onError)(({ graphQLErrors, networkError, response, operation, forward }) => {
    if (graphQLErrors) {
        for (const graphQLError of graphQLErrors) {
            if (graphQLError.error === 'PermissionsError' &&
                graphQLError.type === 'needsTwoFactorCode') {
                if (options.promptTwoFactorCode) {
                    return (0, handleTwoFactor_1.default)({
                        options,
                        operation,
                        forward
                    });
                }
            }
        }
    }
    if (networkError) {
        const result = (0, onNetworkError_1.default)({ networkError, operation, forward });
        if (result)
            return result;
    }
    return options.onError({ graphQLErrors, networkError, response, operation, forward });
});
